// frontend/src/utils/siteLanguage.js
//
// The site-wide language preference, as the public pages store it.
//
// `localStorage.language` is written by AuthLayout's toggle (every page under
// it - the homepage, the blog, the landings) as "hebrew" or "english". Hebrew
// is the product default, so the read tests for the explicit opt-OUT
// (`=== "english"`), never `=== "hebrew"`: an absent key means "never toggled",
// not "English". Same rule as CookieConsentBanner / PwaAwarenessSnackbar /
// enterprisePayText.readIsHebrew.
//
// Both halves are guarded: storage throws in some private modes and when site
// data is blocked, and an unreadable preference is simply the default - never
// a crashed page. A failed write only means the choice is not remembered.

export const LANGUAGE_STORAGE_KEY = "language";

/**
 * Is the site currently in Hebrew? Hebrew unless the visitor chose English.
 *
 * @returns {boolean}
 */
export function readSiteIsHebrew() {
  try {
    return window.localStorage.getItem(LANGUAGE_STORAGE_KEY) !== "english";
  } catch {
    return true;
  }
}

/**
 * Remember the visitor's language choice, in AuthLayout's exact format, so the
 * next page they open (and the homepage they return to) follows it.
 *
 * @param {boolean} isHebrew
 */
export function writeSiteLanguage(isHebrew) {
  try {
    window.localStorage.setItem(
      LANGUAGE_STORAGE_KEY,
      isHebrew ? "hebrew" : "english"
    );
  } catch {
    // Storage unavailable - the page still switches; only the memory is lost.
  }
}
